<template>
  <MuiForm
    v-model="formData"
    class="SignUpCompanyStep3 Step__form"
    @submit.native="handlerFormSubmit"
  >
    <h1
      class="Step__title h1"
    >
      {{ $t('Views.company_signup.step_3.title') }}
    </h1>
    <div
      class="Step__subtitle"
    >
      {{ $t('Views.company_signup.step_3.subtitle') }}
    </div>
    <h3
      class="Step__form_company-title h3"
    >
      {{ $t('Views.company_signup.titles.company_admin_details') }}
    </h3>
    <div>
      {{ $t('Views.company_signup.titles.company_field_info') }}
    </div>

    <MuiInputFile
      :on-change="(e, files) => uploadAdminID(files)"
      :full-width="true"
      :required="true"
      :custom-error-messages="{
        empty: $t('Views.company_signup.fields.upload_admin_id_mandatory'),
        maxFileSize: $t('Views.company_signup.fields.upload_admin_id_size_exceeded')
      }"
      :label="$t('Views.company_signup.fields.upload_admin_id')"
      :placeholder="$t('Views.company_signup.fields.upload_admin_id')"
      :button-text="$t('Views.company_signup.fields.upload_admin_id_button')"
      name="adminID"
      accept=".pdf,.jpg,.jpeg,.png"
      max-file-size="2mb"
    />

    <h3 class="Step__form__work-title h3">
      {{ $t('Views.company_signup.titles.company_legal_info') }}
    </h3>
    <div>{{ $t('Views.company_signup.titles.company_field_info') }}</div>

    <MuiInputFile
      :on-change="(e, files) => uploadProofIncorporation(files)"
      :full-width="true"
      :custom-error-messages="{
        empty: $t('Views.company_signup.fields.upload_admin_id_mandatory'),
        maxFileSize: $t('Views.company_signup.fields.upload_admin_id_size_exceeded')
      }"
      :label="$t('Views.company_signup.fields.upload_prof')"
      :placeholder="$t('Views.company_signup.fields.upload_prof')"
      :button-text="$t('Views.company_signup.fields.upload_prof_button')"
      accept=".pdf,.jpg,.jpeg,.png"
      name="proofIncorporation"
      max-file-size="2mb"
    />

    <MuiInputSiret
      v-if="data.country === 'FR'"
      :required="true"
      :on-change="(e, v) => siretNumber(v)"
      :value="data.siretNumber"
      name="siretNumber"
      label="fields.siret"
      placeholder="fields.siret"
    />

    <MuiInputTax
      v-if="data.country === 'IT'"
      :required="true"
      :on-change="(e, v) => adminFiscalNumber(v)"
      :selected="data.adminFiscalNumber"
      size="xs"
      prefix-placeholder="Country"
      label="fiscal_code"
      placeholder="fiscal_code"
      name="adminFiscalNumber"
      default-country="it"
    />

    <MuiCheckbox
      :label="getGenericTranslation"
      :selected="data.termsAndConditions"
      :required="true"
      :value="true"
      :on-checked="(e, v) => termsAndConditions(v)"
      :error-message="$t('Views.company_signup.errors.checkbox')"
      class="Step__form__terms-and-conditions font-m"
      name="termsAndConditions"
      size="xs"
    />

    <MuiCheckbox
      :label="getDocumentOperator"
      :selected="data.operatorTermsAndConditions"
      :required="true"
      :value="true"
      :on-checked="(e, v) => operatorTermsAndConditions(v)"
      :error-message="$t('Views.company_signup.errors.checkbox')"
      name="operatorTermsAndConditions"
      class="Step__form__terms-and-conditions font-m"
      size="xs"
    />

    <MuiCheckbox
      :label="$t('Views.company_signup.fields.marketingTerms')"
      :selected="data.marketingTerms"
      :value="true"
      :on-checked="(e, v) => marketingTerms(v)"
      name="marketingTerms"
      class="Step__form__terms-and-conditions font-m"
      size="xs"
    />

    <!-- <MuiCheckbox
      v-if="data.country === 'IT'"
      :label="$t('Views.company_signup.fields.italyTermsAndConditions', {url1: 'link1'})"
      :selected="data.italyTermsAndConditions"
      :required="true"
      :value="true"
      :on-checked="(e, v) => italyTermsAndConditions(v)"
      name="italyTermsAndConditions"
      size="xs"
      class="Step__form__terms-and-conditions font-m"
    /> -->

    <MuiButtonFlat
      :submit="true"
      :disabled="disabledSubmitButton"
      class="Step__form__next-button"
      @click.native="signupCompany"
    >
      {{ $t('Views.company_signup.actions.create') }}
    </MuiButtonFlat>
  </MuiForm>
</template>
<script>

import moment from 'moment';
import { mapState, mapMutations, mapActions } from 'vuex';
// import LanguageService from '@/vue/refactor/services/Language';
import {
  MuiForm,
  MuiButtonFlat,
  MuiInputFile,
  MuiCheckbox,
  MuiInputTax,
  MuiInputSiret,
  ModalSizes,
} from '@ubeeqo/motion-ui';
import { DATE_FORMAT } from '@ubeeqo/web-utils';

import { COMPANY_MODULE, GENERAL_MODULE } from '@/constants/modules';

export default {
  name: 'SignUpCompanyStep3View',
  components: {
    MuiForm,
    MuiInputFile,
    MuiButtonFlat,
    MuiCheckbox,
    MuiInputSiret,
    MuiInputTax,
  },
  data() {
    return {
      formData: {},
      disabledSubmitButton: false,
    };
  },
  computed: {
    ...mapState(COMPANY_MODULE, {
      done: state => state.done,
      data: state => state.data,
      documents: state => state.info.legalDocuments,
      companyCreated: state => state.companyCreated,
      linkAccount: state => state.linkAccount,
    }),
    ...mapState(GENERAL_MODULE, [
      'locale',
    ]),
    getDocumentOperator() {
      // const i18nLocale = this.$store.state.i18n.locale;
      // const languageService = this.locale(LanguageService.getInstance().getLanguage());
      // const languageService = LanguageService.getInstance();

      // const locale = i18nLocale || languageService.getLanguage();
      // const languageCode = languageService.getLanguageCodeFromLocale(locale);
      const languageCode = 'en-GB';

      const url = `${this.documents.operator.url}&language=${languageCode}`;
      return this.$t(
        'Views.company_signup.fields.operatorConditions',
        { url1: `<a href="${url}">${this.documents.operator.document_name}</a>` },
      );

      // return '<a href="">link</a>';
    },
    getGenericTranslation() {
      /* const i18nLocale = this.$store.state.i18n.locale;
      const languageService = LanguageService.getInstance();
      const locale = i18nLocale || languageService.getLanguage();
      const languageCode = languageService.getLanguageCodeFromLocale(locale); */
      const languageCode = 'en-GB';

      const urlObject = {};
      this.documents.generic.forEach((doc, index) => {
        // eslint-disable-next-line
        const url = doc.url + '&language=' + languageCode;
        urlObject[`url${index + 1}`] = `<a href="${url}" target="_blank">${doc.document_name}</a>`;
      });
      return this.$t('Views.company_signup.fields.conditions', urlObject);
      // return 'conditions';
    },
  },
  watch: {
    formData(value) {
      if (value.valid) {
        this.doneStep('step3');
      } else {
        this.unDoneStep('step3');
        // this.signupCompany();
      }
    },
  },
  created() {
    /* if (!this.done.step2) {
      this.$router.push('./step2');
      return;
    } */

    // When is not link account, we have to remove IDP_UUID from local storage
    if (this.linkAccount.isLinkAccount === false) {
      // AuthService.removeTokenFromLocalStorage();
    }
  },
  methods: {
    ...mapMutations(COMPANY_MODULE, [
      'adminID',
      'adminIDBase64',
      'adminFiscalNumber',
      'incorporationProof',
      'incorporationProofBase64',
      'siretNumber',
      'termsAndConditions',
      'operatorTermsAndConditions',
      'italyTermsAndConditions',
      'doneStep',
      'unDoneStep',
      'updateStep',
      'resetCompany',
      'marketingTerms',
    ]),
    ...mapActions(COMPANY_MODULE, [
      'createCompany',
      'linkUserCompany',
    ]),
    uploadAdminID(files) {
      this.disabledSubmitButton = true;
      if (files && files.length) {
        this.getBase64(files[0]).then((path) => {
          this.adminIDBase64(path);
          this.adminID(files[0].name);
          this.disabledSubmitButton = false;
        });
      } else {
        this.adminIDBase64('');
        this.adminID('');
        this.disabledSubmitButton = false;
      }
    },
    uploadProofIncorporation(files) {
      this.disabledSubmitButton = true;
      if (files && files.length) {
        this.getBase64(files[0]).then((path) => {
          this.incorporationProofBase64(path);
          this.incorporationProof(files[0].name);
          this.disabledSubmitButton = false;
        });
      } else {
        this.incorporationProofBase64('');
        this.incorporationProof('');
        this.disabledSubmitButton = false;
      }
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },
    showSuccessModal(data) {
      const self = this;
      this.$modal.show('SuccessModal', {
        size: ModalSizes.small,
        closeButton: false,
        content: {
          props: {
            text: this.$t('Views.company_signup.titles.company_created'),
          },
        },
        acceptButton: {
          text: this.$t('Views.company_signup.actions.next'),
          type: 'info',
          action: () => {
            self.resetCompany();
            // Redirect to Impersonate to autologin
            if (data.idp_uuid && data.expires_at && data.refresh_token && data.token) {
              this.$router.replace({
                name: 'ImpersonationView',
                query: {
                  access_token: data.token,
                  idp_uuid: data.idp_uuid,
                  expires_at: data.expires_at,
                  webapp_impersonate: true,
                },
              });
            } else {
              // this.$router.push('/', () => location.reload());
            }
          },
        },
      });
    },
    signupCompany() {
      if (this.formData.valid) {
        if (this.linkAccount.isLinkAccount) {
          this.linkUserCompany({
            locale: this.locale,
          }).then((response) => {
            if (this.companyCreated) {
              this.disabledSubmitButton = false;
              this.showSuccessModal(response.data.admin);
            }
          });
        } else {
          this.disabledSubmitButton = true;
          this.createCompany().then((response) => {
            if (this.companyCreated) {
              // Track Segment
              this.track(response);
              // Success Modal
              this.showSuccessModal({
                idp_uuid: response.data.admin.idp_uuid,
                expires_at: response.data.admin.expires_at,
                refresh_token: response.data.admin.refresh_token,
                token: response.data.admin.token,
              });
            }

            this.disabledSubmitButton = false;
          });
        }
      }
    },
    handlerFormSubmit() {
      if (this.$data.formData.valid) {
        this.doneStep('step2');
        this.updateStep('step3');
        this.$router.push('./step3');
      }
    },
    track(response) {
      const { admin, company } = response.data;

      // Track Company
      this.$segments.trackGroup(company.uuid, {
        address: company.address,
        createdAt: moment().format(DATE_FORMAT.filter),
        email: company.email,
        employees: company.size,
        id: company.uuid,
        name: company.commercial_name,
        phone: company.phone,
      });

      this.$segments.trackSegment('Company Created', {
        company_name: company.commercial_name,
        address: company.address,
        email: company.email,
      });

      // Track Employee to Company
      this.$segments.trackSegment('Employee Created', {
        company_name: company.commercial_name,
        address: company.address,
        email: company.email,
        groupId: company.uuid,
        company: company.uuid,
        id: admin.uuid,
      });
    },
  },
};
</script>
